<template>
  <div style="text-align: center; max-width:900px; margin:auto">
    <img
      v-if="!userLogged.profile"
      src="public/images/site/ver.svg"
      id="Ver"
      alt="Miles de proyectos"
      style="width:80%"
    />

    <section
      v-if="(categorias.length>0)"
      style=" border-radius:15px; background-color: #ececec; padding-top: 50px; padding-bottom: 30px; margin-left: 20px; margin-right: 20px;"
    >
      <h3 v-if="userLogged.profile != 'ADMINISTRADOR'">Categorías</h3>

      <div class="container">
        <div class="row" style="justify-content: center">
          <app-category
            v-for="(category,index) in categorias"
            :category="category"
            v-bind:key="index"
          ></app-category>
          <div
            v-if="userLogged.profile == 'ADMINISTRADOR'"
            @click="nuevaCategoria()"
            class="card categoria"
            style="background-color: grey"
          >
            <img src="public/images/arkidians/nuevo.svg" width="200px" alt="Arkidia" />
            <div class="card-body">
              <h3 class="text-white">Nueva categoría</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <img
      v-if="userLogged.profile != 'ADMINISTRADOR'"
      src="public/images/site/paint-grey.svg"
      id="challenges"
      alt="Miles de proyectos"
      style=" margin-top:-5px; "
    />
  </div>
</template>


<script>
import Categories from "./Category.vue";
import { mapGetters } from "vuex";

export default {
  data: function() {
    return {
      categories: []
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "categoriaSeleccionada"])
  },
  methods: {
    nuevaCategoria() {
      this.$router.push({ path: "/Admin/Categorias/Nueva" });
    }
  },
  mounted: function() {},
  components: {
    appCategory: Categories
  }
};
</script>


// WEBPACK FOOTER //
// src/components/categories/CategoriesGrid.vue